'use strict';

import Highcharts from "highcharts/highstock.src";
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('highchart', function ($timeout, defaultChartOptions) {
  var seriesId = 0;
  var ensureIds = function ensureIds(series) {
    series.forEach(function (s) {
      if (!angular.isDefined(s.id)) {
        s.id = "series-" + seriesId++;
      }
    });
  };
  var getMergedOptions = function getMergedOptions(scope, element, config, height) {
    var mergedOptions = angular.copy(defaultChartOptions);

    // allows to remove an Export action from the defaut Chat options, attibute is an array with id of the action
    if (config.removeExportOptions) {
      var menuItems = mergedOptions.exporting.buttons.contextButton.menuItems;
      mergedOptions.exporting.buttons.contextButton.menuItems = _.filter(menuItems, function (e) {
        return _.indexOf(config.removeExportOptions, e.id) === -1;
      });
    }

    // permet d'ajouter des items au menu d'export sans retirer ceux par défaut.
    // ex : exportMenuItems: [{
    //                     id: "showAll",
    //                     text: "Afficher tout",
    //                     onclick: function () {
    //                         _.each(this.series, function (ser) {
    //                             ser.show();
    //                         });
    //                     }
    //                 }
    if (config.exportMenuItems) {
      var _menuItems = mergedOptions.exporting.buttons.contextButton.menuItems;
      _.each(config.exportMenuItems, function (item) {
        mergedOptions.exporting.buttons.contextButton.menuItems.push(item);
      });
    }
    if (config.options) {
      $.extend(true, mergedOptions, config.options);
    }
    if (height) {
      mergedOptions.chart.height = height;
    }
    mergedOptions.chart.renderTo = element[0];
    if (config.title) {
      mergedOptions.title = config.title;
    }
    if (config.series) {
      mergedOptions.series = config.series;
    }
    return mergedOptions;
  };
  var processSeries = function processSeries(chart, series) {
    // filter navigator series from current series
    var currentSeries = _.filter(chart.series, function (serie) {
      return serie.options.id !== "highcharts-navigator-series";
    });
    var newSeriesIds = [];
    if (series != null) {
      ensureIds(series);

      //Find series to add or update
      _.each(series, function (s) {
        newSeriesIds.push(s.id);
        var chartSeries = chart.get(s.id);
        if (chartSeries) {
          chartSeries.update(s, false);
        } else {
          chart.addSeries(angular.copy(s), false);
        }
      });
    }
    _.each(currentSeries, function (serie) {
      if (newSeriesIds.indexOf(serie.options.id) === -1) {
        serie.remove(false);
      }
    });
  };
  var initializeChart = function initializeChart(scope, element, config, height) {
    config || (config = {});
    var mergedOptions = getMergedOptions(scope, element, config, height);
    var chart = config.useHighStocks ? Highcharts.stockChart(mergedOptions) : Highcharts.chart(mergedOptions);

    // processSeries(chart, config.series && config.series.length ? config.series : mergedOptions.series);

    if (config.loading) {
      chart.showLoading();
    }
    chart.redraw();
    chart._originalOptions = mergedOptions;

    // Passe les éventuelles options fullScreen
    chart.fsOptions = config.fsOptions;
    return chart;
  };
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="highchart"></div>',
    scope: {
      config: '='
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        autoresize = true,
        height = null,
        chart = null;
      ctrl.getChart = function () {
        return chart;
      };
      ctrl.setAutoResize = function (_autoresize) {
        autoresize = _autoresize;
      };
      ctrl.onResize = function () {
        if (autoresize) {
          ctrl.redraw();
        }
      };
      ctrl.setHeight = function (_height) {
        height = _height;
        if (chart) {
          // PGA - if resize animation trigger just before setSeries's redraw, the series wont be redrawn.
          // this trick fix the probleme 99% of the time on initial data load. Enjoy debugging the last 1%.
          var animate = chart.series.length > 0;
          chart.setSize($element.width(), height, animate);
        }
      };
      ctrl.redraw = function () {
        // this is the only fu*** way to redraw correctly a chart...
        $element.is(":visible") && chart && chart.setSize($element.width(), height || $element.height(), false);
      };
      ctrl.initializeChart = function (config) {
        if (chart) {
          chart.destroy();
        }
        chart = initializeChart($scope, $element, config, height);
      };
      ctrl.setTitle = function (title) {
        chart.setTitle(title, true);
      };
      ctrl.setSeries = function (series) {
        processSeries(chart, series);
        chart.redraw();
      };
      ctrl.dispose = function () {
        if (chart) {
          chart.destroy();
          chart = null;
        }
      };
    },
    link: function link($scope, $element, $attrs, ctrl) {
      var unwatch = $scope.$watch("config", function (config) {
        if (config == null) {
          return;
        }
        unwatch();
        ctrl.initializeChart($scope.config);
        $scope.$watch("config.title", function (newTitle) {
          ctrl.setTitle(newTitle);
        }, true);
        $scope.$watch("config.options", function (newOptions, oldOptions) {
          if (newOptions === oldOptions) {
            return;
          }
          ctrl.initializeChart($scope.config);
        }, true);
        $scope.$watch("config.series", function (newSeries, oldSeries) {
          if (newSeries === oldSeries) {
            return;
          }
          ctrl.setSeries(newSeries);
        });
        $scope.$on("$redraw", function () {
          ctrl.redraw();
        });
        $scope.$on("$resize", function () {
          ctrl.onResize();
        });
        $scope.$on("$destroy", function () {
          ctrl.dispose();
        });
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/highcharts.js
// module id = 2966
// module chunks = 13